var React = require('react');

function ArrowCircleRight (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"24","cy":"24","r":"23.25","stroke":"black","strokeWidth":"1.5","key":0}),React.createElement("path",{"d":"M16.5 24H31.5","stroke":"black","strokeWidth":"1.5","key":1}),React.createElement("path",{"d":"M34 23.9993L29 28.4634V19.5352L34 23.9993Z","fill":"black","key":2})]);
}

ArrowCircleRight.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"};

module.exports = ArrowCircleRight;

ArrowCircleRight.default = ArrowCircleRight;
